import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import EmpowerYourLocalBusiness from "./sections/EmpowerYourLocalBusiness";
import TheTransformationPillars from "./sections/TheTransformationPillars";
import TheConciergeEdge from "./sections/TheConciergeEdge";
import Services from "./sections/Services";
import EverythingYouNeedToKnow from "./sections/EverythingYouNeedToKnow";
import StartYourClimateUpgrade from "./sections/StartYourClimateUpgrade";
import ServiceAreaConnection from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <EmpowerYourLocalBusiness />
      <TheTransformationPillars />
      <TheConciergeEdge />
      <Services />
      <EverythingYouNeedToKnow />
      <StartYourClimateUpgrade />
      <ServiceAreaConnection />
    </div>;
}